export default {"src":"/_next/static/media/calendar-days.de318306.svg","height":16,"width":16};